<p>search-form works!</p>

<form
  *ngIf="state === 'ready'"
  name="mainSearchForm"
  (ngSubmit)="onSubmit()"
>
  <input
    [class]="'test'"
    [type]="'text'"
    [formControl]="form.controls.type"
    [placeholder]="''"
    [id]="'1'"
    [name]="'test_name'"
  />
  <button>
    Найти
  </button>
</form>
